import styled from "@emotion/styled";
import { genericStyles } from "../../../../../constant";

export const StyledChatInputWrapper = styled.div`
  padding: 12px;
  background: #f9fafb;

  .ai-tools {
    display: flex;
    gap: 4px;
    margin-bottom: 7px;
    border-bottom: 1px solid #e5e2f0;
    padding-bottom: 7px;
    overflow-x: auto;
    button {
      padding: 3px 9px;
      border-radius: 6px;
      font-size: 11px;
      font-weight: 500;
      display: flex;
      align-items: center;
      gap: 3px;
      color: #5c5470;
      background: #f4f3f9;
      border: 1px solid #e5e2f0;
      white-space: nowrap;
    }
  }

  .input-box {
    display: flex;
    align-items: center;
    gap: 10px;
    border: 1px solid #e5e7eb;
    background: #ffffff !important;
    border-radius: 28px;
    padding: 2px 5px;
    transition:
      border-color 0.2s ease,
      box-shadow 0.2s ease;

    &:has(.voice-input) {
      position: relative;
    }
    overflow: hidden;

    .icon-btn {
      color: #52525b !important;
      font-size: 20px;
    }

    &:focus-within {
      border-color: ${genericStyles.primaryColor};
      box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.15);
    }
    .attach-button {
      color: ${genericStyles.primaryColor};
      font-size: 18px;
    }

    .emoji-button {
      font-size: 25px;
      padding: 0;
    }

    .emoji-picker {
      position: absolute;
      z-index: 10000;
      bottom: 62px;
    }

    .text-message-input {
      border: none !important;
      box-shadow: none !important;
      resize: none;
      font-size: 16px;
      color: #111827;
      background: transparent;
      &::placeholder {
        color: #9ca3af;
      }
    }
  }

  @media (max-width: 767px) {
    .emoji-picker {
      left: 0;
      right: 0;
      padding: 10px;
      .EmojiPickerReact {
        width: 100% !important;
      }
    }
  }

  .file-messenger-container {
    position: absolute;
    top: 73px;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;
    height: calc(100% - 73px) !important;
    display: flex;
    flex-direction: column;
    background: #f0f2f5;
    color: #111b21;
  }

  .preview-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
  }

  .content-middle-div {
    padding: 20px;
    height: calc(100% - 150px);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .file-name-display {
    flex: 1;
    text-align: end;
    font-size: 16px;
    font-weight: 500;
    color: #111b21;
    padding: 0 20px;
  }

  .preview-content {
    background: #f0f2f5;
    position: relative;
    overflow: hidden;
    height: 100%;
  }

  .preview-image {
    height: 100%;
    object-fit: contain;
    border-radius: 5px;
    width: 100%;
  }

  .preview-file-icon {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }

  .file-icon-large {
    font-size: 80px;
    color: ${genericStyles.primaryColor};
  }

  .file-details {
    text-align: center;
  }

  .file-name-text {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 8px;
    word-break: break-word;
    max-width: 300px;
  }

  .file-size-text {
    font-size: 14px;
    color: #667781;
  }

  .preview-footer {
    padding: 12px 20px;
    background: #ffffff;
    border-top: 1px solid #e9edef;
  }

  .ant-badge-count {
    top: 8px !important;
  }

  .thumbnails-strip {
    display: flex;
    gap: 8px;
    width: calc(100% - 55px);
    overflow-x: auto;
    align-items: center;
    justify-content: center;
  }

  .thumbnail-item {
    position: relative;
    flex-shrink: 0;
    width: 60px;
    height: 60px;
    border-radius: 6px;
    overflow: hidden;
    cursor: pointer;
    border: 2px solid transparent;
    transition: all 0.3s;
  }

  .thumbnail-item:hover {
    border-color: ${genericStyles.primaryColor};
  }

  .thumbnail-item.active {
    border-color: ${genericStyles.primaryColor};
    box-shadow: 0 0 0 2px rgba(0, 168, 132, 0.3);
  }

  .thumbnail-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .thumbnail-file {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #e9edef;
    font-size: 24px;
    color: ${genericStyles.primaryColor};
  }

  .thumbnail-remove {
    position: absolute;
    top: 2px;
    right: 2px;
    background: rgba(0, 0, 0, 0.7);
    border: none;
    color: white;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    font-size: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s;
  }

  .thumbnail-item:hover .thumbnail-remove {
    opacity: 1;
  }

  .add-more-thumbnail {
    flex-shrink: 0;
    width: 60px;
    height: 60px;
    border-radius: 6px;
    border: 2px dashed #d1d7db;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s;
    background: #f0f2f5;
  }

  .add-more-thumbnail:hover {
    border-color: ${genericStyles.primaryColor};
    background: #e9edef;
  }

  .add-icon {
    font-size: 24px;
    color: #667781;
  }

  .add-more-thumbnail:hover .add-icon {
    color: ${genericStyles.primaryColor};
  }

  .edit-message-button {
    font-size: 20px;
  }

  .message-input-area {
    display: flex;
    justify-content: center;
    gap: 12px;
    background: #f0f2f5;
    border-radius: 8px;
    padding: 8px;
    margin: 10px 0px;
    width: 100%;
  }

  .message-textarea {
    max-width: 70%;
  }

  /* Full screen overlay */
  .drag-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(24, 24, 24, 0.65);
    backdrop-filter: blur(6px);
    z-index: 9999;

    display: flex;
    align-items: center;
    justify-content: center;

    animation: fadeIn 0.2s ease-in-out;

    .drag-box {
      border: 2px dashed #ffffff;
      text-align: center;
      color: #ffffff;

      background: rgba(255, 255, 255, 0.05);
      transition: all 0.2s ease;

      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      flex-direction: column;
    }

    /* Hover effect while dragging */
    .drag-box:hover {
      border-color: #40a9ff;
      background: rgba(64, 169, 255, 0.1);
    }

    .drag-icon {
      font-size: 40px;
      margin-bottom: 10px;
    }

    .drag-text {
      font-size: 16px;
      opacity: 0.9;
    }

    @keyframes fadeIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
  }
`;

export const StyledRewriteBody = styled.div`
  .rewrite-label {
    font-size: 12px;
    font-weight: 700;
    color: #94a3b8;
    text-transform: uppercase;
    letter-spacing: 0.9px;
    margin-bottom: 6px;
  }

  .original-div {
    .original-box {
      background: #f8fafc;
      border: 1px solid #e2e8f0;
      border-radius: 13px;
      padding: 13px 16px 13px 22px;
      font-size: 14.5px;
      color: #334155;
      line-height: 1.55;
      position: relative;
    }
  }

  .action-tabs {
    display: flex;
    gap: 8px;
    background: #f0f5ff;
    border-radius: 14px;
    padding: 6px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    margin: 20px 0px;
    .action-tab {
      flex: 1;
      padding: 10px 8px;
      border-radius: 10px;
      cursor: pointer;
      border: none !important;
      background: transparent;
      color: #5c6f91;
      font-size: 13px;
      font-weight: 500;
    }
    .action-tab:hover {
      color: ${genericStyles.primaryColor} !important;
      background: transparent !important;
    }

    .action-tab.active {
      background: ${genericStyles.primaryColor} !important;
      color: #ffffff !important;
    }

    .action-tab .tab-icon {
      font-size: 16px;
    }
  }

  /* ── Language Row ── */
  .lang-row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 20px;
    .lang-select {
      flex: 1;
    }
    button {
      margin-top: 24px !important;
    }
  }

  /* ── Result Box ── */
  .result-box {
    margin-top: 20px;
    animation: slideDown 0.25s ease;
    margin-bottom: 20px;

    .result-text {
      font-size: 15px;
      color: #1a1a2e;
      font-weight: 500;
      line-height: 1.5;
      padding: 12px 14px;
      background: #f7f8ff;
      border-radius: 10px;
      border: 1px solid #eef0ff;
    }

    /* ── Accept / Ignore Buttons ── */
    .accept-ignore-row {
      display: flex;
      gap: 8px;
      margin-top: 20px;
      width: 100%;
    }
  }

  /* ── Suggestions List ── */
  .suggestions-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 4px;

    .suggestion-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 14px;
      background: #f7f8ff;
      border: 1px solid #eef0ff;
      border-radius: 10px;
      transition:
        border-color 0.2s,
        background 0.2s;
    }

    .suggestion-item:hover {
      border-color: #c7c5ff;
      background: #eeefff;
    }

    .suggestion-text {
      font-size: 14px;
      color: #1a1a2e;
      font-weight: 500;
    }
  }
`;

export const StyledVoiceInput = styled.div`
  display: flex;
  align-items: center;

  .vi-recording-row {
    display: flex;
    align-items: center;
    justify-content: end;
    gap: 8px;
    padding: 0 10px 0px 20px;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: 1111;
    background: white;
  }

  .vi-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #ef4444;
    animation: vi-pulse 1s ease-in-out infinite;
  }

  .vi-live-transcript {
    flex: auto 1 1;
    font-size: 12px;
    color: #71717a;
    font-style: italic;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: stretch;
    max-width: fit-content;
  }

  @keyframes vi-pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.3;
    }
  }

  .vi-timer {
    font-size: 13px;
    color: #52525b;
    min-width: 36px;
    font-variant-numeric: tabular-nums;
  }

  .vi-bars {
    display: flex;
    align-items: center;
    gap: 3px;
    height: 20px;
    overflow: hidden;
  }

  .vi-bar {
    width: 3px;
    border-radius: 2px;
    background: #a1a1aa;
    animation: vi-bar-bounce 0.9s ease-in-out infinite;
  }

  @keyframes vi-bar-bounce {
    0%,
    100% {
      height: 4px;
    }
    50% {
      height: 16px;
    }
  }
`;
